export enum HomeScreen {
    Dashboard = 'dashboard',
    HomeWidgets = 'home_widgets',
    Signacademy = 'signacademy',
    Reseller = 'reseller',
}
